import React from 'react';
import { observer } from 'mobx-react';

import { banner, banner2x, banner3x, bannerMobile, bannerMobile2x, bannerMobile3x } from './images';
import { Footer } from '../../../common/footer';
import { HomeNavbar } from '../../../common/home-navbar';
import { InformationMenu } from '../information-menu';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import styles from './AboutUs.css';
import { routeNaming, AppLink } from '../../../routes';
import { SEO } from '../../../common/seo';

const AboutUs = observer(() => {
  const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
  return (
    <div className={styles.container}>
      <SEO
        title="Quiénes somos"
        description="Accede a toda la información relevante sobre Carlos Gutiérrez S.A, nuestros servicios, políticas y cómo podemos ayudarte. Encuentra detalles sobre nuestros productos, condiciones de uso, privacidad, envíos y más. Estamos comprometidos a ofrecerte la mejor experiencia, brindándote transparencia y claridad en todos nuestros procesos. Si tienes preguntas o dudas, esta sección es tu recurso principal para obtener respuestas. Descubre todo lo que necesitas saber y disfruta de una experiencia de compra segura y satisfactoria con nosotros"
        type="website"
      />
      <HomeNavbar />
      <div className={styles.mainWrapper}>
        <div className={styles.mainContent}>
          {showMobileVersion ?
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.INFORMATION_MENU_MOBILE}
              >
                Información
              </AppLink>
              <span> &gt; Quienes somos</span>
            </p>
            : <InformationMenu indexSelectedItem={4} />}
          <div className={styles.bodyContainer}>
            <div className={styles.titleContainer}>
              <h1 className={styles.mainTitle}> Quienes somos </h1>
            </div>
            <div className={styles.outlinedContainer}>
              <p className={styles.textContext}>
                Carlos Gutiérrez abrió su empresa en 1964 queriendo ser
                exitoso en su emprendimiento. Nunca pensó que iba a crear
                un modelo de negocios, pero lo hizo. Nosotros, en equipo,
                nos proponemos el desafío de perfeccionarlo.
              </p>
            </div>
            <h2 className={styles.title}>Sobre nosotros</h2>
            <p className={styles.bodyTextContent}>
              Nuestra base es el modelo que Carlos Gutiérrez se dedicó
              a pensar, armar y ajustar a lo largo de los años. Una
              forma de hacer negocios de forma efectiva y confiable
              buscando ofrecer la mejor opción al cliente.
            </p>
            <p className={styles.bodyTextContent}>
              Hacer posible que muchos uruguayos accedan a productos de
              última generación por precios accesibles y con la mejor financiación,
              es la satisfacción de nuestro fundador y nuestro propósito.
            </p>
            <p className={styles.bodyTextContent}>
              Con equipo renovado seguimos siendo una empresa familiar. Continuamos
              la tradición de ofrecer el mejor precio siempre en una muy
              pensada selección de productos de valor.
            </p>
            <p className={styles.bodyTextContent}>
              Trabajamos con muchas ganas para ofrecer una experiencia
              de compra fácil, rápida y segura. A pesar de haber llegado
              a más hogares de los que imaginábamos, sabemos que tenemos
              mucho para mejorar.
            </p>
            <p className={styles.bodyTextContent}>
              ¡Gracias a nuestros clientes por confiar en nosotros a lo largo de tantos años!
            </p>
            <div className={styles.imageContainter}>
              {
                showMobileVersion ?
                  <img
                    className={styles.mobileImage}
                    src={bannerMobile}
                    srcSet={`${bannerMobile2x} 2x, ${bannerMobile3x} 3x`}
                    alt=""
                  />
                  :
                  <img
                    className={styles.image}
                    src={banner}
                    srcSet={`${banner2x} 2x, ${banner3x} 3x`}
                    alt=""
                  />
              }
            </div>
            <h2 className={styles.title}>Nuestros productos</h2>
            <p className={styles.bodyTextContent}>
              Ofrecemos artículos para hacer la vida más fácil y disfrutable.
            </p>
            <p className={styles.bodyTextContent}>
              La curiosidad sobre cada una de sus características y
              su desempeño nos enseñan la forma de desarrollarlos.
              Investigamos y testeamos cada producto exhaustivamente
              hasta estar convencidos que es una excelente opción.
            </p>
            <p className={styles.bodyTextContent}>
              Queremos seguir componiendo nuestra selección de productos
              haciendo foco en innovaciones relevantes y
              que nuestro conocimiento en electrodomésticos ayude a los consumidores.
            </p>
            <h2 className={styles.title}>Nuestras marcas</h2>
            <p className={styles.bodyTextContent}>
              Nuestras dos marcas exclusivas Panavox y Bronx nos representan.
              <br />
              Creamos cada producto en base a las características de su marca
              pero basados siempre en los mismos valores, con las mismas ganas
              y la misma confianza de proponer una excelente opción.
              Al presentarlos, buscamos ser claros para que los usuarios
              decidan de acuerdo a sus necesidades.
            </p>
            <p className={styles.bodyTextContent}>
              <b>PANAVOX Tecnología y calidad al mejor precio.</b>
              <br />
              Desde 1977 los productos Panavox han ido evolucionando en tecnología,
              desempeño y prestaciones.  Años de investigación, análisis y búsqueda
              de desarrollo sostenido han formado líneas de productos confiables,
              innovadores y sólidos a la vez, al mejor precio.
            </p>
            <p className={styles.bodyTextContent}>
              <b>BRONX  Tecnología tradicional accesible para toda familia.</b>
              <br />
              Son productos confiables, clásicos y fáciles de usar con costos convenientes.
              BRONX es una sólida marca que crece.
            </p>
            <p className={styles.bodyTextContent}>
              Nuestro objetivo es proponer la mejor opción a nuestros clientes.  Eso nos
              inspira a seguir buscando satisfacer sus expectativas y en lo posible superarlas.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
});

export { AboutUs };



// WEBPACK FOOTER //
// ./src/pages/information/about-us/AboutUs.jsx